import {
  Box,
  Grid,
  GridItem,
  Heading,
  Text,
  VStack,
  Button,
  Flex,
  useToast,
  useDisclosure,
  Select,
  Input,
} from "@chakra-ui/react";

import { MultiSelect } from "react-multi-select-component";

// import ReactECharts from "echarts-for-react";

import { useContext, useEffect, useState } from "react";
import { appContext } from "../Context/AppContext";
import { useNavigate } from "react-router-dom";
import CrmDataService from "../services/data";
import AnalyticsDataService from "../services/analytics";
import { BsInfoCircleFill } from "react-icons/bs";
import ConfirmationModal from "../Component/Modals/ConfirmationModal";
import { TbLogout } from "react-icons/tb";
import { MdDashboard } from "react-icons/md";

export default function Home() {
  const { setPageId } = useContext(appContext);
  const navigate = useNavigate();
  const toast = useToast();
  const loggedInUser = localStorage.getItem("logged_in_user_id");

  const storedPermissions =
    localStorage.getItem("logged_in_user_permissions") || "[]";
  // console.log(storedPermissions);
  const userPermissions = storedPermissions
    ? JSON.parse(storedPermissions)
    : [];

  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [confirmFunction, setConfirmFunction] = useState<() => void>(() => {});

  const [leadLastSyncedBy, setLeadLastSyncedBy] = useState<any>({
    syncDate: "",
    syncTime: "",
    userEmail: "",
  });

  const [customerLastSyncedBy, setCustomerLastSyncedBy] = useState<any>({
    syncDate: "",
    syncTime: "",
    userEmail: "",
  });

  const [statusCount, setStatusCount] = useState<any>({
    HOT: "",
    WARM: "",
    COLD: "",
    SINGLE: "",
    SUBSCRIPTION: "",
  });

  // const [status, setStatus] = useState("");

  const [customerLoading, setCustomerLoading] = useState(false);
  const [leadLoading, setLeadLoading] = useState(false);

  const [prompt, setPrompt] = useState("");
  const [htmlContent, setHtmlContent] = useState("");
  const [graphLoading, setGraphLoading] = useState(false);

  const handleNavigation = (tabName: string) => {
    setPageId(tabName);
    navigate("dashboard");
  };

  const openModal = (action: () => void) => {
    setConfirmFunction(() => action);
    onOpen();
  };

  const syncLeads = async () => {
    setLeadLoading(true);
    const email = localStorage.getItem("logged_in_email");

    await CrmDataService.fetchnewleads(email).then((res) => {
      setLeadLoading(false);
      toast({
        position: "top",
        title: "Leads Synced.",
        description: "Leads are synced successfully.",
        status: "success",
        duration: 1000,
        isClosable: true,
      });
    });
  };

  const syncCustomers = async () => {
    setCustomerLoading(true);

    const email = localStorage.getItem("logged_in_email");
    await CrmDataService.fetchnewcustomers(email).then((res) => {
      setCustomerLoading(false);
      toast({
        position: "top",
        title: "Customers Synced.",
        description: "Customers are synced successfully.",
        status: "success",
        duration: 1000,
        isClosable: true,
      });
    });
  };

  const calibrateLeadCustomer = async () => {
    const email = localStorage.getItem("logged_in_email");
    await CrmDataService.calibrate(email).then((res) => {
      setCustomerLoading(false);
      toast({
        position: "top",
        title: "Status Calibrated.",
        description: "Status calibrated successfully.",
        status: "success",
        duration: 1000,
        isClosable: true,
      });
    });
  };

  const syncDetails = () => {
    CrmDataService.getSyncDetails().then((res) => {
      if (res.data) {
        setLeadLastSyncedBy({
          syncDate: res.data.lead.last_synced_by.date || "",
          syncTime: res.data.lead.last_synced_by.time || "",
          userEmail: res.data.lead.last_synced_by.email || "",
        });

        setCustomerLastSyncedBy({
          syncDate: res.data.customer.last_synced_by.date || "",
          syncTime: res.data.customer.last_synced_by.time || "",
          userEmail: res.data.customer.last_synced_by.email || "",
        });
      }
    });
  };

  const getCounts = () => {
    CrmDataService.getStatusCount().then((res) => {
      if (res.data) {
        setStatusCount({
          HOT: res.data.HOT || "",
          WARM: res.data.WARM || "",
          COLD: res.data.COLD || "",
          SINGLE: res.data.SINGLE || "",
          SUBSCRIPTION: res.data.SUBSCRIPTION || "",
        });
      }
    });
  };

  const getAnalytics = async (prompt: any) => {
    try {
      setGraphLoading(true);
      const res = await AnalyticsDataService.getGraph(prompt);
      const cleanedHtml = res.data.replace(/^```html\s*|\s*```$/g, "");
      setGraphLoading(false);
      setHtmlContent(cleanedHtml);
    } catch (err) {
      console.error("Failed to fetch chart:", err);
      setHtmlContent('<p style="color: red;">Failed to generate chart.</p>');
    }
  };

  const capitalize = (str: any) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    syncDetails();
    getCounts();
    // getAnalytics(prompt);
  }, []);

  return (
    // <ChakraProvider>
    <Box bg="#f0f7f7" minH="100vh" pb={6} display="flex" flexDirection="column">
      {/* <Flex
        bg="#406661"
        color="white"
        p={4}
        justify="center"
        alignItems="center"
        position="relative"
      >

        <Heading size="md">DOLPHIN</Heading>
        <Flex
          position="absolute"
          right={4}
          top="50%"
          transform="translateY(-50%)"
          cursor="pointer"
          fontWeight="medium"
          fontSize="lg"
          onClick={handleLogout}
          color="#fff"
          alignItems="center"
          gap={2}
          direction="row"
        >
          <TbLogout size="20" />
          <Text fontSize="sm">Logout</Text>
        </Flex>
      </Flex> */}

      <Flex
        bg="#406661"
        color="white"
        p={4}
        justify="space-between"
        alignItems="center"
      >
        <Flex
          align="center"
          gap={2}
          cursor="pointer"
          onClick={() => navigate("/admin")}
        >
          {userPermissions.includes("hotleads") && <MdDashboard size={20} />}
          <Text fontSize="sm" fontWeight="medium">
            {accessControls.includes("salesAdmin")
              ? "Admin Dashboard"
              : userPermissions.includes("hotleads")
              ? "Consultant Dashboard"
              : ""}
          </Text>
        </Flex>

        <Heading size="md" textAlign="center">
          DOLPHIN
        </Heading>

        <Flex align="center" gap={2} cursor="pointer" onClick={handleLogout}>
          <TbLogout size={20} />
          <Text fontSize="sm">Logout</Text>
        </Flex>
      </Flex>

      <VStack mt={8} align="center" flex="1">
        <Text fontSize="lg" fontWeight="bold">
          Welcome{" "}
          {(loggedInUser?.includes("_")
            ? capitalize(loggedInUser.split("_")[1])
            : capitalize(loggedInUser)) || "User"}
        </Text>

        <Flex justify="center" align="center" w="100%" pb={12}>
          <Grid
            templateColumns="repeat(auto-fit, minmax(200px, 0fr))"
            gap={4}
            w="auto"
            maxW="1200px"
          >
            {/* {userPermissions.includes("hotleads") && ( */}
            <GridItem width="200px">
              <Box
                bg="#f5a623"
                p={4}
                borderRadius="md"
                color="white"
                textAlign="center"
              >
                <Heading size="sm">LEADS</Heading>
              </Box>
              <VStack mt={2}>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("hot-leads")}
                  isDisabled={!userPermissions.includes("hotleads")}
                  opacity={userPermissions.includes("hotleads") ? 1 : 0.6}
                  cursor={
                    userPermissions.includes("hotleads")
                      ? "pointer"
                      : "not-allowed"
                  }
                >
                  Hot Leads
                </Button>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("warm-leads")}
                  isDisabled={!userPermissions.includes("hotleads")}
                  opacity={userPermissions.includes("hotleads") ? 1 : 0.6}
                  cursor={
                    userPermissions.includes("hotleads")
                      ? "pointer"
                      : "not-allowed"
                  }
                >
                  Warm Leads
                </Button>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("cold-leads")}
                  isDisabled={!userPermissions.includes("hotleads")}
                  opacity={userPermissions.includes("hotleads") ? 1 : 0.6}
                  cursor={
                    userPermissions.includes("hotleads")
                      ? "pointer"
                      : "not-allowed"
                  }
                >
                  Cold Leads
                </Button>
                <Flex
                  // gap="5"
                  w="100%"
                  maxW="700px"
                  justifyContent="start"
                  alignItems="center"
                  mt="auto"
                  mx="auto"
                >
                  <div className="">
                    <div className="info-icon">
                      <BsInfoCircleFill color="#fdb508" fontSize="14px" />
                    </div>
                    <div className="info-content bg-light ml-2 mb-5">
                      <div className="sync-text">Leads Count</div>
                      <div className="sync-subtext">
                        HOT :{" "}
                        <span className="sync-count">{statusCount.HOT}</span>
                      </div>
                      <div className="sync-subtext">
                        WARM :{" "}
                        <span className="sync-count">{statusCount.WARM}</span>
                      </div>
                      <div className="sync-subtext">
                        COLD :{" "}
                        <span className="sync-count">{statusCount.COLD}</span>
                      </div>
                    </div>
                  </div>
                </Flex>
              </VStack>
            </GridItem>
            {/* )} */}
            {/* {userPermissions.includes("single") && ( */}
            <GridItem width="200px">
              <Box
                bg="#f5a623"
                p={4}
                borderRadius="md"
                color="white"
                textAlign="center"
              >
                <Heading size="sm">CUSTOMERS</Heading>
              </Box>
              <VStack mt={2}>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("single")}
                  isDisabled={!userPermissions.includes("single")}
                  opacity={userPermissions.includes("single") ? 1 : 0.6}
                  cursor={
                    userPermissions.includes("single")
                      ? "pointer"
                      : "not-allowed"
                  }
                >
                  Single Session
                </Button>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("subscription")}
                  isDisabled={!userPermissions.includes("single")}
                  opacity={userPermissions.includes("single") ? 1 : 0.6}
                  cursor={
                    userPermissions.includes("single")
                      ? "pointer"
                      : "not-allowed"
                  }
                >
                  Subscription
                </Button>
                <Flex
                  // gap="5"
                  w="100%"
                  maxW="700px"
                  justifyContent="start"
                  alignItems="center"
                  mt="auto"
                  mx="auto"
                >
                  <div className="">
                    <div className="info-icon">
                      <BsInfoCircleFill color="#fdb508" fontSize="14px" />
                    </div>
                    <div className="info-content bg-light ml-2 mb-5">
                      <div className="sync-text">Customers Count</div>
                      <div className="sync-subtext">
                        SINGLE :{" "}
                        <span className="sync-count">{statusCount.SINGLE}</span>
                      </div>
                      <div className="sync-subtext">
                        SUBSCRIPTION :{" "}
                        <span className="sync-count">
                          {statusCount.SUBSCRIPTION}
                        </span>
                      </div>
                    </div>
                  </div>
                </Flex>
              </VStack>
            </GridItem>
            {/* )} */}
            <GridItem width="200px">
              <Box
                bg="#f5a623"
                p={4}
                borderRadius="md"
                color="white"
                textAlign="center"
              >
                <Heading size="sm">MARKETING</Heading>
              </Box>
              <VStack mt={2}>
                {/* {userPermissions.includes("reachoutlogs") && ( */}
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("leads-reachout")}
                  isDisabled={!userPermissions.includes("reachoutlogs")}
                  opacity={userPermissions.includes("reachoutlogs") ? 1 : 0.6}
                  cursor={
                    userPermissions.includes("reachoutlogs")
                      ? "pointer"
                      : "not-allowed"
                  }
                >
                  Leads Reach Out
                </Button>
                {/* )} */}

                {/* {userPermissions.includes("reachoutlogs") && ( */}
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("customer-reachout")}
                  isDisabled={!userPermissions.includes("reachoutlogs")}
                  opacity={userPermissions.includes("reachoutlogs") ? 1 : 0.6}
                  cursor={
                    userPermissions.includes("reachoutlogs")
                      ? "pointer"
                      : "not-allowed"
                  }
                >
                  Customer Reach Out
                </Button>
                {/* )} */}

                {/* {userPermissions.includes("reachoutlogs") && ( */}
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("reachout-logs")}
                  isDisabled={!userPermissions.includes("reachoutlogs")}
                  opacity={userPermissions.includes("reachoutlogs") ? 1 : 0.6}
                  cursor={
                    userPermissions.includes("reachoutlogs")
                      ? "pointer"
                      : "not-allowed"
                  }
                >
                  Reach Out Logs
                </Button>
                {/* )} */}

                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("followup-logs")}
                  isDisabled={!userPermissions.includes("followuplogs")}
                  opacity={userPermissions.includes("followuplogs") ? 1 : 0.6}
                  cursor={
                    userPermissions.includes("followuplogs")
                      ? "pointer"
                      : "not-allowed"
                  }
                >
                  Followup Logs
                </Button>
              </VStack>
            </GridItem>
            <GridItem width="200px">
              <Box
                bg="#f5a623"
                p={4}
                borderRadius="md"
                color="white"
                textAlign="center"
              >
                <Heading size="sm">ANALYTICS</Heading>
              </Box>
              <VStack mt={2}>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("contact-analytics")}
                >
                  Contacts
                </Button>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("analytics")}
                >
                  App Therapists
                </Button>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() =>
                    handleNavigation("free-consultation-analytics")
                  }
                >
                  Free Consultation
                </Button>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("assessment-analytics")}
                >
                  Assessment
                </Button>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("session-analytics")}
                >
                  Sessions
                </Button>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() => handleNavigation("booking-analytics")}
                >
                  Bookings
                </Button>
                <Button
                  colorScheme="teal"
                  variant="outline"
                  w="100%"
                  onClick={() =>
                    handleNavigation("user-registration-analytics")
                  }
                >
                  User Registrations
                </Button>
              </VStack>
            </GridItem>
          </Grid>
        </Flex>
      </VStack>

      {/* <Flex
        w="100%"
        maxW="1400px"
        justifyContent="start"
        alignItems="center"
        mt="auto"
        mx="auto"
        gap="5"
      >
        <Text fontSize="md" fontWeight="semibold">
          Show
        </Text>
        <Select
          placeholder="Select"
          value={selectedType}
          // onChange={handleEmailChange}
        >
          {graphOptions.map((item: any, index: any) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </Select>

        <Text fontSize="md" fontWeight="semibold">
          Of
        </Text>

        <Select
          placeholder="Select"
          value={selectedType}
          // onChange={handleEmailChange}
        >
          {typeOptions.map((item: any, index: any) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </Select>

        <Select
          placeholder="Select"
          value={selectedType}
          // onChange={handleEmailChange}
        >
          {categoryOptions.map((item: any, index: any) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </Select>

        <Text fontSize="md" fontWeight="semibold">
          From
        </Text>

        <Input
          type="date"
          // value={selectedDate}
          // onChange={(e) => setSelectedDate(e.target.value)}
        />

        <Text fontSize="md" fontWeight="semibold">
          To
        </Text>

        <Input
          type="date"
          // value={selectedDate}
          // onChange={(e) => setSelectedDate(e.target.value)}
        />

        <Text fontSize="md" fontWeight="semibold">
          On
        </Text>

        <Select
          placeholder="Select"
          value={selectedType}
          // onChange={handleEmailChange}
        >
          {platformOptions.map((item: any, index: any) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </Select>

        {/* <Input
          type="text"
          paddingLeft={2}
          bg="white"
          id="image"
          name="image"
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Enter prompt"
          value={prompt}
        /> */}

      {/* <Button
          colorScheme="yellow"
          size="sm"
          width="800px"
          // onClick={() => getAnalytics(prompt)}
        >
          GENERATE
        </Button>
      // </Flex> */}

      {/* <Flex justify="center" align="center" w="100%">
        <Box
          mt={4}
          p={4}
          borderWidth="1px"
          borderRadius="md"
          boxShadow="md"
          minH="300px"
          w="100%"
          maxW="1000px"
        >
          {graphLoading && (
            <Flex justify="center" align="center" minH="300px">
              <PuffLoader
                color="#fdb508"
                size={100}
                cssOverride={{
                  visibility: graphLoading ? "visible" : "hidden",
                }}
              />
            </Flex>
          )}

          {!graphLoading && (
            <Box mt={6} border="1px solid" borderColor="gray.300">
              <iframe
                srcDoc={htmlContent}
                title="Chart Output"
                style={{ width: "100%", height: "500px", border: "none" }}
                sandbox="allow-scripts allow-same-origin"
              />
            </Box>
          )}
        </Box>
      </Flex> */}

      {/* <Flex
        // gap="5"
        w="100%"
        maxW="1000px"
        justifyContent="start"
        alignItems="center"
        mt="auto"
        mx="auto"
      >
        <div className="parent-sync-count">
          <div className="info-icon">
            <BsInfoCircleFill color="#fdb508" fontSize="14px" />
          </div>
          <div
            className="info-content bg-light ml-2 mb-5"
            style={{
              width: "240px",
            }}
          >
            <div className="sync-text">Last Sync</div>
            <div className="sync-subtext">
              Date :{" "}
              <span className="sync-count">{leadLastSyncedBy.syncDate}</span>
            </div>
            <div className="sync-subtext">
              Time :{" "}
              <span className="sync-count">{leadLastSyncedBy.syncTime}</span>
            </div>
            <div className="sync-subtext">
              User :{" "}
              <span className="sync-count">{leadLastSyncedBy.userEmail}</span>
            </div>
          </div>
        </div>
        <div className="parent-sync-count">
          <div className="info-icon">
            <BsInfoCircleFill color="#fdb508" fontSize="14px" />
          </div>
          <div
            className="info-content bg-light ml-2"
            style={{
              width: "240px",
            }}
          >
            <div className="sync-text">Last Sync</div>
            <div className="sync-subtext">
              Date :{" "}
              <span className="sync-count">
                {customerLastSyncedBy.syncDate}
              </span>
            </div>
            <div className="sync-subtext">
              Time :{" "}
              <span className="sync-count">
                {customerLastSyncedBy.syncTime}
              </span>
            </div>
            <div className="sync-subtext">
              User :{" "}
              <span className="sync-count">
                {customerLastSyncedBy.userEmail}
              </span>
            </div>
          </div>
        </div>
        <div className="parent-sync-count">
          <div className="info-icon">
            <BsInfoCircleFill color="#fdb508" fontSize="14px" />
          </div>
          <div
            className="info-content bg-light ml-2"
            style={{
              width: "240px",
            }}
          >
            <div className="sync-text">Last Sync</div>
            <div className="sync-subtext">
              Date :{" "}
              <span className="sync-count">
                {customerLastSyncedBy.syncDate}
              </span>
            </div>
            <div className="sync-subtext">
              Time :{" "}
              <span className="sync-count">
                {customerLastSyncedBy.syncTime}
              </span>
            </div>
            <div className="sync-subtext">
              User :{" "}
              <span className="sync-count">
                {customerLastSyncedBy.userEmail}
              </span>
            </div>
          </div>
        </div>
      </Flex> */}

      {/* <Flex
        gap="6"
        w="100%"
        maxW="1000px"
        justifyContent="center"
        alignItems="center"
        mt="auto"
        mx="auto"
      >
        <Button
          colorScheme="teal"
          variant="outline"
          w="100%"
          className="loader"
          onClick={() => openModal(syncLeads)}
        >
          <div
            style={{ marginLeft: "25px" }}
            // onClick={() => setStatus("hot")}
          >
            Sync Leads
          </div>
          <ClipLoader
            color="#327171"
            size={20}
            cssOverride={{
              visibility: leadLoading ? "visible" : "hidden",
            }}
          />
        </Button>
        <Button
          colorScheme="teal"
          variant="outline"
          w="100%"
          className="loader"
          onClick={() => openModal(syncCustomers)}
        >
          <div
            style={{ marginLeft: "25px" }}
            // onClick={() => setStatus("single")}
          >
            Sync Customers
          </div>
          <ClipLoader
            color="#327171"
            size={20}
            cssOverride={{
              visibility: customerLoading ? "visible" : "hidden",
            }}
          />
        </Button>
        <Button
          colorScheme="teal"
          variant="outline"
          w="100%"
          onClick={() => openModal(calibrateLeadCustomer)}
        >
          Calibrate Status
        </Button>
        <Button
          colorScheme="teal"
          variant="outline"
          w="100%"
          disabled
          // onClick={() => calibrateLeadCustomer()}
        >
          Calibrate Data
        </Button>
      </Flex>
      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={() => {
          confirmFunction();
          onClose();
        }}
      /> */}
    </Box>

    // </ChakraProvider>
  );
}
